export default __webpack_public_path__ + "static/media/nftstudios.2459324c.png";